import { createSelector } from 'reselect'
import { State } from 'index'

const storeDeliveryBreadSelector = (state: State) => state.storeDeliveryBread

export const getStoreDeliveryBread = createSelector([storeDeliveryBreadSelector], (state) => state)
